import React from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'

const CREModalEliminar = (props: any) => {
  return (
    <ModalBase Styles={{minWidth: '30%', maxWidth: '400px', backgroundColor: '#f1f1f1', padding:"1.5%"}}>
      <div className='modal-content'>
        <div className='w-layout-hflex'>
          <h3 className='card-title l'>{props.eliminar ? 'Quitar documento' : 'Quitar todos los documentos'}</h3>
        </div>
        <div className='form-separator'></div>
        <p>
          {props.eliminar ? '¿Seguro que quieres quitar este documento? Esta acción no se puede deshacer.'
            : '¿Seguro que quieres quitar todos los documentos asociados de esta lista? Esta acción no se puede deshacer.'}
        </p>
        <div className='form-separator'></div>
        <div className='w-layout-hflex button-actions'>
          <button className='m button transparent w-inline-block' onClick={props.closeModalEliminar}>
            <div>Cancelar</div>
          </button>
          <button className='m button delete w-inline-block' onClick={props.actionEliminar}>
            <div>{props.eliminar ? 'Quitar' : 'Quitar todo'}</div>
          </button>
        </div>
      </div>
    </ModalBase>
  )
}

export default CREModalEliminar
